import { Button } from "@/components/ui/button";
import { GuestCountFields } from "./GuestCountFields";
import { GuestSummary } from "./GuestSummary";

export const ReservationGuestEditor = ({ reservation, value, onChange, prefix, disabled = false }) => (
  value ? <GuestCountFields value={value} onChange={onChange} prefix={prefix} disabled={disabled} /> :
    <div className="space-y-3">
      <GuestSummary reservation={reservation} prefix={`${prefix}-original`} />
      <Button type="button" variant="outline" disabled={disabled} data-testid={`${prefix}-add-breakdown`}
        onClick={() => onChange({ adults_count: 0, children_count: 0 })}>
        Aufteilung erfassen
      </Button>
    </div>
);